/* eslint-disable react/prop-types */
import React, { useState, useEffect, useContext, useRef } from "react"; //import the component part of React
import withRouter from "../WithRouter";
import { useNavigate } from "react-router-dom";
import FadeIn from "../common/FadeIn";
//Packages
import axios from "axios";
import { Col, Row, Container, Button } from "react-bootstrap";
//Subcomponents
import ClassInfo from "./page-parts/ClassInfo";
import OtherClasses from "./page-parts/OtherClasses";
//Loading
import LoadingSpinner from "../LoadingSpinner";
//Context
import { BusinessContextConsumer } from "../BusinessContext";
//Analytics
import TagManager from "react-gtm-module";

const SignupClassView = (props) => {
  // State
  const [classData, setClassData] = useState("");
  const [otherClasses, setOtherClasses] = useState([]);
  const [prorationPrice, setProrationPrice] = useState("");
  // Get the classID and context.
  const classid = props.params.classid;
  const BusinessContext = useContext(BusinessContextConsumer);
  const { businessID, currencySymbol } = BusinessContext;
  // ref the class ID
  const prevClassId = useRef(); //Reference the previous class ID to ensure new get request if it changes.
  // Get the class proration data if needed
  useEffect(async () => {
    prevClassId.current = classid; // Assign Refs Value to current load

    // Request the Class Data
    const classDataRequest = await axios.get(
      `/api/public_view/class_selected_plus/${businessID}/${classid}/`,
      {
        withCredentials: true,
      }
    );

    // Get the proration price only if necessary
    const returnedData = classDataRequest.data;
    if (returnedData.classData.Prorate && !returnedData.classData.monthStartBilling) {
      const prorationPriceRequest = await axios.get(
        `/api/public_view/class_selected/prorate/${businessID}/${classid}/`,
        {
          withCredentials: true,
        }
      );
      setProrationPrice(prorationPriceRequest.data.prorationPrice);
    }

    TagManager.dataLayer({
      dataLayer: {
        event: "viewedClassWithoutLogin",
        lessonType: returnedData.classData.LessonType,
      },
    });
    TagManager.dataLayer({
      dataLayer: {
        event: "view_item",
        ecommerce: {
          items: [
            {
              item_name: returnedData.classData.LessonType,
              price: returnedData.classData.Price,
              item_category: "subscription",
              quantity: 1,
            },
          ],
        },
      },
    });

    setOtherClasses(returnedData.otherClasses);
    return setClassData(returnedData.classData);
  }, [classid]); // Run useEffect when the classID changes to get new class data.

  if (classData) {
    return (
      <FadeIn delay={250} duration={450}>
        <Container>
          <ClassInfo
            prorationPrice={prorationPrice}
            classData={classData}
            currencySymbol={currencySymbol}
            direction="/"
          />
          <PromptButtons classData={classData} />
          <OtherClasses otherClasses={otherClasses} />
        </Container>
      </FadeIn>
    );
  } else {
    return <LoadingSpinner />;
  }
};

const PromptButtons = (props) => {
  const classData = props.classData;
  const navigate = useNavigate();
  const signupClicked = () => {
    sessionStorage.setItem("interestedClass", JSON.stringify(classData._id));
    return navigate("/signup/");
  };
  const loginClicked = () => {
    sessionStorage.setItem("interestedClass", JSON.stringify(classData._id));
    return navigate("/login/");
  };
  return (
    <>
      {classData.MaxLearners > classData.Subscribers_Number ? (
        <Row className='mt-4'>
          <Col>
            <div className='prominentBox p-3'>
              <h3 className='mt-4'>Want to Subscribe?</h3>
              <Button
                variant='success'
                className=' mt-3 mb-4 w-100'
                role='button'
                onClick={() => signupClicked()}
              >
                Sign up
              </Button>
              <p>You will need to sign up and set up participants to register for this class.</p>
            </div>
          </Col>
        </Row>
      ) : (
        <Row className='mt-4'>
          <Col>
            <div className='prominentBox p-3'>
              <h3 className='mt-4'>Join the waiting list!</h3>
              <Button
                variant='success'
                className='mt-3 mb-4 w-100'
                role='button'
                onClick={() => signupClicked()}
              >
                Sign up
              </Button>
              <p>
                This class is presently full but you can join our waiting list and we will notify
                you when a space becomes available. You will need to sign up and set up participants
                to join our waiting list.
              </p>
            </div>
          </Col>
        </Row>
      )}

      <Row>
        <Col className='mt-4 p-3'>
          <h3>Already got a login?</h3>
          <Button
            variant='primary'
            className='mt-3 mb-4 w-100'
            role='button'
            onClick={() => loginClicked()}
          >
            Login
          </Button>
        </Col>
      </Row>
    </>
  );
};

//Export
export default withRouter(SignupClassView);
